import { render } from "./IconHuman.vue?vue&type=template&id=6b5aba2f"
import script from "./IconHuman.vue?vue&type=script&lang=js"
export * from "./IconHuman.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__